var options = {
    root: null,
    rootMargin: "0px 0px 300px 0px",
    threshold: 0
};
var intersectionHandler = function (entries, observer) {
    entries.forEach(function (entry) {
        if (entry.isIntersecting) {
            var el_1 = entry.target;
            var src_1 = getResponsiveSource(el_1);
            if (el_1 instanceof HTMLImageElement) {
                el_1.src = src_1;
                el_1.onload = function (ev) {
                    el_1.style.filter = null;
                };
            }
            else {
                var img = new Image();
                img.onload = function (ev) {
                    el_1.style.filter = null;
                    el_1.style.backgroundImage = "url(\"" + src_1 + "\")";
                };
                img.src = src_1;
            }
            observer.unobserve(entry.target);
        }
    });
};
var observer;
if (!('IntersectionObserver' in window) ||
    !('IntersectionObserverEntry' in window) ||
    !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
    observer = {
        observe: function (el) {
            if (el instanceof HTMLImageElement) {
                el.src = getResponsiveSource(el);
            }
            else {
                el.style.backgroundImage = "url(" + getResponsiveSource(el) + ")";
            }
        }
    };
}
else {
    observer = new IntersectionObserver(intersectionHandler, options);
}
export var getResponsiveSource = function (el) {
    if (window.matchMedia('screen and (min-width: 1440px)').matches) {
        return el.dataset.srcXl || el.dataset.src || '';
    }
    else if (window.matchMedia('screen and (min-width: 1024px)').matches) {
        return el.dataset.srcLg || el.dataset.srcXl || el.dataset.src || '';
    }
    else if (window.matchMedia('screen and (min-width: 768px)').matches) {
        return el.dataset.srcMd || el.dataset.srcLg || el.dataset.srcXl || el.dataset.src || '';
    }
    else {
        return el.dataset.srcSm || el.dataset.srcMd || el.dataset.srcLg || el.dataset.srcXl || el.dataset.src || '';
    }
};
export default observer;
